/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramTransactionsUserControllerCreateIosPaymentMutationRequest,
  TelegramTransactionsUserControllerCreateIosPaymentMutationResponse,
  TelegramTransactionsUserControllerCreateIosPayment400,
  TelegramTransactionsUserControllerCreateIosPayment401,
  TelegramTransactionsUserControllerCreateIosPayment404,
} from '../types/TelegramTransactionsUserControllerCreateIosPayment.ts';

function getTelegramTransactionsUserCreateIosPaymentUrl() {
  const res = { method: 'POST', url: `/api/user/telegram/transactions/ios` as const };
  return res;
}

/**
 * {@link /api/user/telegram/transactions/ios}
 */
export async function telegramTransactionsUserCreateIosPayment(
  data: TelegramTransactionsUserControllerCreateIosPaymentMutationRequest,
  config: Partial<RequestConfig<TelegramTransactionsUserControllerCreateIosPaymentMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramTransactionsUserControllerCreateIosPaymentMutationResponse,
    ResponseErrorConfig<
      | TelegramTransactionsUserControllerCreateIosPayment400
      | TelegramTransactionsUserControllerCreateIosPayment401
      | TelegramTransactionsUserControllerCreateIosPayment404
    >,
    TelegramTransactionsUserControllerCreateIosPaymentMutationRequest
  >({
    method: 'POST',
    url: getTelegramTransactionsUserCreateIosPaymentUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
